export default __webpack_public_path__ + "static/media/avatar.e62a0d99.jpg";